import ChangeTime from "./ChangeTime/ChangeTime.vue";

export default {
    name: "CheckAnalysis",
    components: {
        ChangeTime
    },
    data() {
        return {
            
        };
    },
    mounted() {

    },
    methods: {

    },
};
